/* @flow */

import * as React from 'react';
import type {FieldProps} from 'redux-form';
import {useQuery} from '@apollo/react-hooks';

import type {GetStagesets as GetStagesetsQuery} from 'nutshell-graphql-types';
import {ReduxFormSelectPickerGeneric} from 'shells/redux-form-fields';

import {getDefaultStagesetId} from '../../../../util/get-default-stageset-id';

import GET_STAGESETS from '../../../lead/queries/get-stagesets.graphql';

// Redux-based pipeline select that renders as a dropdown
// (does not turn into a "card" when it has a value)
export function PipelineSelectSingle(props: FieldProps) {
    const {data} = useQuery<GetStagesetsQuery, {}>(GET_STAGESETS, {
        notifyOnNetworkStatusChange: true,
    });

    const options = data
        ? data.stagesets.map((stageset) => {
              return {
                  label: stageset.name,
                  value: stageset.id,
              };
          })
        : [];

    const defaultPipeline = options.find((opt) => opt.value === getDefaultStagesetId());

    React.useEffect(() => {
        if (defaultPipeline && !props.input.value) {
            props.input.onChange(defaultPipeline.value);
        }
    }, [defaultPipeline, props.input]);

    const selectedValue = options.find((field) => field.value === props.input.value);

    return (
        // $FlowIgnore this is because of the way we're passing the props through
        <ReduxFormSelectPickerGeneric
            {...props}
            onRemove={() => props.input.onChange(null)}
            options={options}
            placeholder='Select a pipeline'
            value={selectedValue}
        />
    );
}
